// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Admin__SelectCompanyController from "./admin/select_company_controller"
application.register("admin--select-company", Admin__SelectCompanyController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AgentJumpController from "./agent_jump_controller"
application.register("agent-jump", AgentJumpController)

import AgentPartnershipFormController from "./agent_partnership_form_controller"
application.register("agent-partnership-form", AgentPartnershipFormController)

import AgentPoolSearchController from "./agent_pool_search_controller"
application.register("agent-pool-search", AgentPoolSearchController)

import AgentRankJumpController from "./agent_rank_jump_controller"
application.register("agent-rank-jump", AgentRankJumpController)

import AgentRankRowController from "./agent_rank_row_controller"
application.register("agent-rank-row", AgentRankRowController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import AlternativeController from "./alternative_controller"
application.register("alternative", AlternativeController)

import AutoSelectController from "./auto_select_controller"
application.register("auto-select", AutoSelectController)

import Backoffice__CardOrderingController from "./backoffice/card_ordering_controller"
application.register("backoffice--card-ordering", Backoffice__CardOrderingController)

import Backoffice__CaseWorkerBadgeController from "./backoffice/case_worker_badge_controller"
application.register("backoffice--case-worker-badge", Backoffice__CaseWorkerBadgeController)

import Backoffice__ClipboardController from "./backoffice/clipboard_controller"
application.register("backoffice--clipboard", Backoffice__ClipboardController)

import Backoffice__DetailPanelController from "./backoffice/detail_panel_controller"
application.register("backoffice--detail-panel", Backoffice__DetailPanelController)

import Backoffice__FilterFormController from "./backoffice/filter_form_controller"
application.register("backoffice--filter-form", Backoffice__FilterFormController)

import Backoffice__InlineFormController from "./backoffice/inline_form_controller"
application.register("backoffice--inline-form", Backoffice__InlineFormController)

import Backoffice__KanbanSearchController from "./backoffice/kanban_search_controller"
application.register("backoffice--kanban-search", Backoffice__KanbanSearchController)

import Backoffice__RowLinkController from "./backoffice/row_link_controller"
application.register("backoffice--row-link", Backoffice__RowLinkController)

import Backoffice__WithdrawalDeadlineController from "./backoffice/withdrawal_deadline_controller"
application.register("backoffice--withdrawal-deadline", Backoffice__WithdrawalDeadlineController)

import BankDetailsController from "./bank_details_controller"
application.register("bank-details", BankDetailsController)

import CheckBoxController from "./check_box_controller"
application.register("check-box", CheckBoxController)

import CheckboxSelectionController from "./checkbox_selection_controller"
application.register("checkbox-selection", CheckboxSelectionController)

import ColumnChartController from "./column_chart_controller"
application.register("column-chart", ColumnChartController)

import ComboBoxController from "./combo_box_controller"
application.register("combo-box", ComboBoxController)

import CustomerController from "./customer_controller"
application.register("customer", CustomerController)

import DocumentDropzoneController from "./document_dropzone_controller"
application.register("document-dropzone", DocumentDropzoneController)

import CustomAccordionController from "./custom_accordion_controller"
application.register("custom-accordion", CustomAccordionController)

import DocumentPreviewPanelController from "./document_preview_panel_controller"
application.register("document-preview-panel", DocumentPreviewPanelController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EditableFieldController from "./editable_field_controller"
application.register("editable-field", EditableFieldController)

import ExpandableFormController from "./expandable_form_controller"
application.register("expandable-form", ExpandableFormController)

import ExpandableListController from "./expandable_list_controller"
application.register("expandable-list", ExpandableListController)

import ExportListController from "./export_list_controller"
application.register("export-list", ExportListController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FilteredSelectController from "./filtered_select_controller"
application.register("filtered-select", FilteredSelectController)

import FlashRemovalController from "./flash_removal_controller"
application.register("flash-removal", FlashRemovalController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FormChangeMonitorController from "./form_change_monitor_controller"
application.register("form-change-monitor", FormChangeMonitorController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import FormToggleController from "./form_toggle_controller"
application.register("form-toggle", FormToggleController)

import FormWithNavigationController from "./form_with_navigation_controller"
application.register("form-with-navigation", FormWithNavigationController)

import GenericToggleController from "./generic_toggle_controller"
application.register("generic-toggle", GenericToggleController)

import GlobalSaveButtonController from "./global_save_button_controller"
application.register("global-save-button", GlobalSaveButtonController)

import HideController from "./hide_controller"
application.register("hide", HideController)

import InputDisableController from "./input_disable_controller"
application.register("input-disable", InputDisableController)

import IntersectionController from "./intersection_controller"
application.register("intersection", IntersectionController)

import InvestmentFundController from "./investment_fund_controller"
application.register("investment-fund", InvestmentFundController)

import IsolatedEditableFieldController from "./isolated_editable_field_controller"
application.register("isolated-editable-field", IsolatedEditableFieldController)

import LimitNestedFormController from "./limit_nested_form_controller"
application.register("limit-nested-form", LimitNestedFormController)

import LineChartController from "./line_chart_controller"
application.register("line-chart", LineChartController)

import LoadingBannerController from "./loading_banner_controller"
application.register("loading-banner", LoadingBannerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalWrapperController from "./modal_wrapper_controller"
application.register("modal-wrapper", ModalWrapperController)

import MoneyInputController from "./money_input_controller"
application.register("money-input", MoneyInputController)

import NavCalculationTypeController from "./nav_calculation_type_controller"
application.register("nav-calculation-type", NavCalculationTypeController)

import NumberController from "./number_controller"
application.register("number", NumberController)

import Offers__ProcessDocumentsController from "./offers/process_documents_controller"
application.register("offers--process-documents", Offers__ProcessDocumentsController)

import Offers__StepFiveController from "./offers/step_five_controller"
application.register("offers--step-five", Offers__StepFiveController)

import Offers__StepFourController from "./offers/step_four_controller"
application.register("offers--step-four", Offers__StepFourController)

import Offers__StepThreeController from "./offers/step_three_controller"
application.register("offers--step-three", Offers__StepThreeController)

import PdfDownloadController from "./pdf_download_controller"
application.register("pdf-download", PdfDownloadController)

import PdfExportButtonController from "./pdf_export_button_controller"
application.register("pdf-export-button", PdfExportButtonController)

import PercentageInputController from "./percentage_input_controller"
application.register("percentage-input", PercentageInputController)

import PlayerController from "./player_controller"
application.register("player", PlayerController)

import PolicyApplicationTabsController from "./policy_application_tabs_controller"
application.register("policy-application-tabs", PolicyApplicationTabsController)

import PolicyConsultationController from "./policy_consultation_controller"
application.register("policy-consultation", PolicyConsultationController)

import PolicyParametersFinancingController from "./policy_parameters_financing_controller"
application.register("policy-parameters-financing", PolicyParametersFinancingController)

import PortfolioController from "./portfolio_controller"
application.register("portfolio", PortfolioController)

import ProductComparisonController from "./product_comparison_controller"
application.register("product-comparison", ProductComparisonController)

import ProtectedFormController from "./protected_form_controller"
application.register("protected-form", ProtectedFormController)

import QuickLoginController from "./quick_login_controller"
application.register("quick-login", QuickLoginController)

import RadioController from "./radio_controller"
application.register("radio", RadioController)

import ResetExistingPolicyFieldsController from "./reset_existing_policy_fields_controller"
application.register("reset-existing-policy-fields", ResetExistingPolicyFieldsController)

import ScrollNavigationController from "./scroll_navigation_controller"
application.register("scroll-navigation", ScrollNavigationController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SearchableInputController from "./searchable_input_controller"
application.register("searchable-input", SearchableInputController)

import SellingPolicyCostPrefillController from "./selling_policy_cost_prefill_controller"
application.register("selling-policy-cost-prefill", SellingPolicyCostPrefillController)

import SessionController from "./session_controller"
application.register("session", SessionController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SlimSelectController from "./slim_select_controller"
application.register("slim-select", SlimSelectController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TableController from "./table_controller"
application.register("table", TableController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TrainingController from "./training_controller"
application.register("training", TrainingController)

import TreeController from "./tree_controller"
application.register("tree", TreeController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import TurboToggleController from "./turbo_toggle_controller"
application.register("turbo-toggle", TurboToggleController)

import ValidateSectionsController from "./validate_sections_controller"
application.register("validate-sections", ValidateSectionsController)
